import * as React from 'react';
import FormCheckBox from './FormCheckBox';
import processInput from './processInput';
import OutputsBox from './OutputsBox';

interface State {
  input: string;

  removeBlankLines: boolean;
  removeTrailingSpaces: boolean;
  removeNonHanzi: boolean;
  removeListItemMarkers: boolean;

  convertNumericalPinyin: boolean;
  convertParagraphsToLines: boolean;
}

export default class PinyinToolbox extends React.Component {

  state: State = {
    input: '',

    removeBlankLines: true,
    removeTrailingSpaces: true,
    removeNonHanzi: false,
    removeListItemMarkers: false,

    convertNumericalPinyin: true,
    convertParagraphsToLines: false,
  };

  renderRemoveOptions() {
    return (
      <fieldset className="form-group">
        <div className="row">
          <label className="control-label col-sm-2">Remove</label>
          <div className="col-sm-10">
            <FormCheckBox
              label="blank lines"
              checked={this.state.removeBlankLines}
              onChange={removeBlankLines => this.setState({ removeBlankLines })}
            />
            <FormCheckBox
              label="trailing spaces"
              checked={this.state.removeTrailingSpaces}
              onChange={removeTrailingSpaces => this.setState({ removeTrailingSpaces })}
            />
            <FormCheckBox
              label="non-hanzi"
              checked={this.state.removeNonHanzi}
              onChange={removeNonHanzi => this.setState({ removeNonHanzi })}
            />
            <FormCheckBox
              label="list item markers"
              checked={this.state.removeListItemMarkers}
              onChange={removeListItemMarkers => this.setState({ removeListItemMarkers })}
            />
          </div>
        </div>
      </fieldset>
    );
  }

  renderConvertOptions() {
    return (
      <fieldset className="form-group">
        <div className="row">
          <label className="control-label col-sm-2">Convert</label>
          <div className="col-sm-10">
            <FormCheckBox
              label="numerical pinyin to tone marks"
              checked={this.state.convertNumericalPinyin}
              onChange={convertNumericalPinyin => this.setState({ convertNumericalPinyin })}
            />
            <FormCheckBox
              label="paragraphs to lines"
              checked={this.state.convertParagraphsToLines}
              onChange={convertParagraphsToLines => this.setState({ convertParagraphsToLines })}
            />
          </div>
        </div>
      </fieldset>
    );
  }

  render() {
    return (
      <div className="card PinyinToolbox">
        <div className="card-header">
          <h4 className="card-title">
            Pinyin Toolbox / 拼音工具箱
          </h4>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <h4>Input / 输入</h4>
              <form>
                <div className="form-group">
                  <textarea
                    className="form-control"
                    value={processInput(this.state.input, this.state)}
                    onChange={evt => this.setState({ input: evt.target.value })}
                  />
                </div>
                {this.renderRemoveOptions()}
                {this.renderConvertOptions()}
              </form>
            </div>
            <div className="col-md-6">
              <OutputsBox processedInput={processInput(this.state.input, this.state)} />
            </div>
          </div>
        </div>
      </div >
    );
  }
}
